/**
 * LOG_ID_CONTROL_GENERIC needs to match the value in ClientEventLookup.java in app-core
 * New values should not be added to ClientEventLookup.java in app-core
 * Instead leverage LOG_IDs (see below) and use naming convention: gss-<component>-#
 * Example: "gss-prf-1" which is used for grid-state-service performance telemetry for API actions
 * LOG_ID_CONTROL_GENERIC should be used for the clientEventObjectID
 */
export var LOG_ID_CONTROL_GENERIC = 2005;
/**
 * LOG_IDs should follow format of:  gss-<component>-#
 * "gss" needs to match the value in ClientControlId.java in app-core (to ensure uniqueness)
 * "gss" is "Grid State Service"
 * <component> should be a unique 3 character identifier for a component/area
 * A trailing number is used to differentiate between IDs within a component/area
 */
export var LOG_ID_PERF_API = "gss-prf-1";
/**
 * FLAG_IDs listed here need to match values in GridConfigProperty.java in app-core
 */
export var FLAG_ID_ENABLE_GRID_STATE_BROKER = 36311;
export var FLAG_ID_ENABLE_GRID_STATE_SERVICE_TELEMETRY = 36326;
//# sourceMappingURL=constants.js.map